import { render } from "./RbTitleToolbar.vue?vue&type=template&id=7b467a87&scoped=true"
import script from "./RbTitleToolbar.vue?vue&type=script&lang=js"
export * from "./RbTitleToolbar.vue?vue&type=script&lang=js"

import "./RbTitleToolbar.vue?vue&type=style&index=0&id=7b467a87&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b467a87"]])

export default __exports__